import baseCfg from './base'
import devCfg from './development'
import proCfg from './production'
const setPro = process.env.NODE_ENV === 'production'
let cfg = {}
if (setPro) {
  cfg = Object.assign(baseCfg, proCfg)
} else {
  cfg = Object.assign(baseCfg, devCfg)
}
export default function getCfg(name, defaultValue) {
  if (!name || name.length === 0) {
    return null
  }
  let value = null
  try {
    if (
      window.__beetle_deployments != null &&
      window.__beetle_deployments[name] != null
    ) {
      try {
        value = JSON.parse(window.__beetle_deployments[name])
      } catch (error) {
        value = null
      }
      if (value == null) {
        value = window.__beetle_deployments[name]
      }
    } else {
      try {
        value = JSON.parse(cfg[name])
      } catch (error) {
        value = null
      }
      if (value == null) {
        value = cfg[name]
      }
    }
  } catch (error) {
    value = null
  }

  if (value == null) {
    value = defaultValue
  }

  return value || ''
}
